import { getParents } from "./utils";

export default class Slider {
    constructor($slider, parentSelector) {
        this.initInterval = null;
        this.$slider = $slider;
        this.splideSlider = null;
        this.$sliderArrows = null;
        this.parentSelector = parentSelector;

        this._init();
    }

    _init() {
        // recuperation de la section parent
        const sliderParents = getParents(this.$slider, document.querySelector(this.parentSelector));
        console.log(sliderParents)
        const $parentSection = sliderParents[sliderParents.length - 1];

        // recuperation des fleches custom
        this.$sliderArrows = $parentSection.querySelectorAll('[data-role="slider-navigation"]');

        this.initInterval = setInterval(() => {
            // on attend que le slider soit initialisé
            if (this.$slider.classList.contains('is-initialized')) {
                clearInterval(this.initInterval);
                this._onSliderInitialized();
            }
        }, 50);
    }

    _onSliderInitialized() {
        // recuperation du slider Splide activé par par Bricks Builder
        this.splideSlider = bricksData.splideInstances[this.$slider.dataset.scriptId]
        this._addEvents();
    }

    _addEvents() {
        [...this.$sliderArrows].forEach(($arrow) => {
            $arrow.addEventListener('click', this._onChangeSlide.bind(this))
        })
    }

    _onChangeSlide(e) {
        // changement de slide
        e.currentTarget.dataset.sliderNavigation === 'next' ? this.splideSlider.go( '>' ) : this.splideSlider.go( '<' );
    }
}